import { create } from "zustand";
import { SubTypeValue, SpaceObjectGroup, SpaceObjectType } from "../../types";

type StatusType = "loading" | "ready";

type SpaceObjectStore = {
  spaceObjects: {
    [noradId: number]: SpaceObjectGroup;
  };

  add: (s: SpaceObjectType, uuid: string) => void;
  clear: () => void;
  find: (noradId: number) => SpaceObjectGroup | null;
};

export const useSpaceObjectStore = create<SpaceObjectStore>((set, get) => ({
  spaceObjects: {},
  add: (s, uuid) => {
    const { noradId } = s;
    const spaceObject = {
      [noradId]: {
        ...s,
        uuid
      }
    };

    set(state => {
      state.spaceObjects = { ...state.spaceObjects, ...spaceObject };

      return state;
    });
  },
  clear: () => {
    set(state => {
      state.spaceObjects = {};

      return state;
    });
  },
  find(noradId: number) {
    return get().spaceObjects[noradId] || null;
  }
}));
